import { get } from '../../utils/utils';
import { toItem } from './mappers/item';
import { eventsList } from '../../events/list';
import { sendBi } from '../../services/bi/send-request';
import { BIEventIds } from '../../services/bi/event-ids';
import { createDuplexerChannel, DUPLEXER_EVENTS } from '../../services/socket/createDuplexerChannel';
import { TranscodingStatuses } from '../../constants/transcoding-statuses';
import { emit, emitResolve } from '../../events/notifier';
export function initSocket(settings, adapter) {
  const {
    metaSiteToken
  } = settings;
  const {
    channel
  } = createDuplexerChannel({
    metaSiteToken
  });
  const emitItemUpdateEvent = result => {
    const event = emit(adapter, eventsList.ITEM.UPDATE, {
      arguments: [result.data, result.data]
    });
    event.resolve(result);
  };
  channel.on(DUPLEXER_EVENTS.STATUS_UPDATE, message => {
    if (settings.asyncTranscoding) {
      if (get(message, 'file.op_status') === TranscodingStatuses.READY) {
        adapter.item.get(get(message, 'file.file_name')).then(emitItemUpdateEvent);
      } else {
        emitItemUpdateEvent({
          data: toItem(message.file, settings, {}, true)
        });
      }
    }
  });

  // looks like this event is never fired
  channel.on(DUPLEXER_EVENTS.TRASH_FILE, message => {
    sendBi('/mg', {
      src: 26,
      evid: BIEventIds.BIEventsIds.debugDuplexerEvent,
      type: DUPLEXER_EVENTS.TRASH_FILE,
      message: JSON.stringify(message)
    });
    emitResolve(adapter, eventsList.ITEMS.REMOVE, {
      arguments: [[message.file_name]]
    }, {
      data: {
        id: message.file_name
      }
    });
  });

  // looks like this event is never fired
  channel.on(DUPLEXER_EVENTS.ITEM_UPDATE, message => {
    sendBi('/mg', {
      src: 26,
      evid: BIEventIds.BIEventsIds.debugDuplexerEvent,
      type: DUPLEXER_EVENTS.ITEM_UPDATE,
      message: JSON.stringify(message)
    });
    const item = toItem(message.file, settings, {}, true);
    const event = emit(adapter, eventsList.ITEM.UPDATE, {
      arguments: [item, item]
    });
    event.resolve({
      data: item
    });

    // uncomment when item_update implemented on server side
    /*
    emitResolve(adapter, eventsList.ITEM.UPDATE,
      {arguments: [[item, item]]},
      {data: item}
    );
    */
  });
  return channel;
}